import { postRequest } from '@/core';
import { drivers } from '@/requests';

export default async function saveNewDriverRequest(newDriver) {
	let url = drivers.getPath();
	return postRequest(url, {}, newDriver);
}